/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { DeployTemplateContainer as DeployTemplate } from './DeployTemplate.container';
